import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';

import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Router} from '@angular/router';
import {GridService} from 'app/core-ui/abstract/basegrid/grid.service';
import {ConfigService} from 'app/core-ui/abstract/services/config.service';
import {EventsEmitterService} from 'app/core-ui/abstract/services/emitter.service';
import {LogService} from 'app/core-ui/abstract/services/log.service';
import {catchError, map} from 'rxjs/operators';
@Injectable()
export class OnBoardingDocsService extends GridService {
  constructor(
    http: HttpClient,
    configService: ConfigService,
    eventsEmitterService: EventsEmitterService,
    router: Router,
    logger: LogService,
  ) {
    super(http, configService, eventsEmitterService, router, logger, 'OnBoardingDocsService');
  }

  getRemaining(params): Observable<any> {
    let serviceUrl = this.baseUrl + 'TypeService' + '/getTypeRem';
    return this.http
      .post(serviceUrl, params, {
        headers: this.setAuthorizationHeader(new HttpHeaders()),
      })
      .pipe(map(super.extractData), catchError(super.handleError));
  }
  getAssigned(params): Observable<any> {
    let serviceUrl = this.baseUrl + 'TypeService' + '/getDocumentType';
    return this.http
      .post(serviceUrl, params, {
        headers: this.setAuthorizationHeader(new HttpHeaders()),
      })
      .pipe(map(super.extractData), catchError(super.handleError));
  }

  relate(params: any): Observable<any> {
    let serviceUrl =
      this.baseUrl +
      'TypeService' +
      '/relateDocumentTypeToCompany';
    return this.request(serviceUrl, this.setPostParams(params)).pipe(
      map(super.extractData),
      catchError(super.handleError),
    );
  }

  // unAssign(params: any, table: any, col: any): Observable<any> {
  //   let serviceUrl =
  //     this.baseUrl +
  //     'TypeService' +
  //     '/unlinkDocumentTypeFromCompany?lkupTable=' +
  //     table +
  //     '&lkupCol=' +
  //     col;
  //   return this.request(serviceUrl, this.setPostParams(params)).pipe(
  //     map(super.extractData),
  //     catchError(super.handleError),
  //   );
  // }
}
